<app-dialog [dialogWithInput]="dialog">
    <app-card>
        <strong>Lien: </strong><a href="{{dialog.input.signUrl}}">{{dialog.input.signUrl}}</a>
        <div class="row">
            <app-form-field label="Envoyer par" [required]="true">
                <app-select-filter-v2 (_onSingleSelectionChange)="typeChanged()" [elements]="typeElements" [parentFormGroup]="formGroup" parentFormControlName="type"></app-select-filter-v2>
            </app-form-field>
        </div>
        <div class="row">
            <ng-container *ngIf="formGroup.get('type').value === 'email'">
                <app-form-field label="Adresse e-mail" [required]="true">
                    <app-email-input [parentFormGroup]="formGroup.get('email')"
                                                      parentFormControlName="to"></app-email-input>
                </app-form-field>
                <app-form-field label="Sujet" [required]="true">
                    <app-input-text [parentFormGroup]="formGroup.get('email')"
                                     parentFormControlName="subject"></app-input-text>
                </app-form-field>
                <app-form-field label="Contenu" [required]="true" [size]="12" [sizeXl]="12" [sizeLg]="12">
                    <app-communication-content-editor [parentFormGroup]="formGroup"
                                                      parentFormControlName="content"></app-communication-content-editor>
                </app-form-field>

            </ng-container>
            <ng-container *ngIf="formGroup.get('type').value === 'sms'">
                <app-form-field label="Numéro de téléphone" [required]="true">
                    <app-phone-input [parentFormGroup]="formGroup.get('sms').get('to')"
                    [initialPayload]="phoneNumber"></app-phone-input>

                </app-form-field>
                <app-form-field label="Contenu" [required]="true" [size]="12" [sizeXl]="12" [sizeLg]="12">
                    <app-sms-content-input
                            [parentFormGroup]="formGroup"
                            parentFormGroupName="content"></app-sms-content-input>
                    </app-form-field>
            </ng-container>
        </div>
    </app-card>
    <app-button dialog-actions [loading]="service.loading$ | async" fill="solid" iconName="send" label="Envoyer" (clickEvent)="send()"></app-button>
</app-dialog>